<template>
  <div>
    <div :class="inputClass" class="form-group">
      <label class="name form-control__label" :for="id + randomID">{{ labelText }}</label>

      <div v-if="isLocationAutocomplete" class="text-autocomplete--wrapper">
        <input 
          :class="[
            'form-control', 
            'address-autocomplete',
            isSelected ? 'selected' : 'not-set'
          ]"
          :autocomplete="'not-autofill--search-field' + randomID"
          v-model="internalLocationName"
          v-bind="getFieldProperties"
          :id="id + randomID"
          @blur="checkAutocompleteSelected()"
          @focus="onFocus"
          @input="autocompleteUpdateValue($event.target.value)"
          @keyup="autocompleKeyEvent"
          @keydown="preventSubmit"
        />

        <div class="custom-dropdown-not-found--values" v-if="autocompleteExpanded && notfound">
          <div class="inner">
           <p>Address not found, please <a href="mailto:info@colorsteel.co.nz">contact us</a></p>
          </div>
        </div>

        <div class="custom-dropdown--values" v-else-if="autocompleteExpanded && autocompleteList.length>0">
          <div class="inner">
            <a href="#"
              :key="index"
              v-for="(item, index) in autocompleteList"
              tabindex="-1"
              :class="[
                index===autocompleteSelected ? 'focus' : null
              ]"
              @click.prevent="setSelectedItem(index)"
            >{{ item.label }}</a>
          </div>
        </div>
      </div>

      <input v-else class="form-control"
        v-model="internalModel"
        v-bind="getFieldProperties"
        @blur="onBlur"
        @focus="onFocus"
        @input="updateValue($event.target.value)"
      />
    </div>
    <p v-if="helpText" v-html="helpText" class="h5 mt--2x"></p>
    <form-errors :errors="errors" />
  </div>
</template>

<script>
// import FormControlMixin from '@/js/mixins/FormControlMixin';
import axios from 'axios';
import { debounce } from 'vue-debounce';
import FormControlMixin from '../../mixins/FormControlMixin';

export default {
  mixins: [FormControlMixin],
  props: {
    type: { type: String, default: 'text' },
    isLocationAutocomplete: { type: Boolean, default: false },
  },
  data() {
    return {
      randomID: '',
      autocompleteExpanded: true,
      autocompleteList: [],
      autocompleteSelected: null,
      apiKey: '331246_eKnqmFhae8yS6JNH',
      notfound: false,
      isSelected: false,
    };
  },
  computed: {
    internalLocationName: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('locationUpdated', value);
      },
    },
    inputClass() {
      return {
        'form-control': true,
        'form-control--has-value': this.internalModel !== '',
        'form-control--input': true,
      };
    },
    getFieldProperties() {
      return {
        class: 'form-control__field',
        name: this.name,
        type: this.type,
        id: this.id,
        required: this.required,
        ...this.$attrs,
      };
    },
  },
  created() {
    const app = this;
    app.debourceHandlerEvent = debounce((keyword) => {
      app.debourceHandler(keyword);
    }, 500);

    this.randomID = this.randomString();
  },
  methods: {
    randomString() {
      return this.getRandomizedString();
    },
    debourceHandlerEvent() {},
    debourceHandler(keyword) {
      const app = this;
      axios.get(`https://addressright.co.nz/autocomplete.json?api_key=${this.apiKey}&per_page=8&term=${keyword}`)
        .then((response) => {
          app.autocompleteList = response.data;
       
          if(app.autocompleteList.length > 0 || keyword.length < 3){
              app.notfound = false;
          }
          else{
              app.notfound = true;
          }

        })
        .catch((error) => {
          console.log(error);
        });
    },

    preventSubmit(ev){
      if (ev.keyCode == 13) {
        ev.preventDefault();
        this.setSelectedItem(this.autocompleteSelected);
        return false;
      }
    },

    autocompleKeyEvent(ev) {
      if (this.autocompleteList.length > 0) {

        if (ev.keyCode == 38) {
          if (this.autocompleteSelected === null) {
            this.autocompleteSelected = this.autocompleteList.length - 1;
          } else {
            this.autocompleteSelected -= 1;
            if (this.autocompleteSelected < 0) {
              this.autocompleteSelected = this.autocompleteList.length - 1;
            }
          }
        }
        if (ev.keyCode == 40) {
          if (this.autocompleteSelected === null) {
            this.autocompleteSelected = 0;
          } else {
            this.autocompleteSelected += 1;
            if (this.autocompleteSelected >= this.autocompleteList.length) {
              this.autocompleteSelected = 0;
            }
          }
        }
      }
    },
    setSelectedItem(index) {
      const selItem = this.autocompleteList[index];
      const app = this;
      const url = `https://addressright.co.nz/address.json?api_key=${this.apiKey}&id=${selItem.id}`;

      app.internalLocationName = selItem.label;

      this.isSelected = true;

      axios.get(url)
        .then((response) => {
          const { structured_address } = response.data;
          const cleanAddress = [
            `${structured_address.street_number} ${structured_address.street_name} ${structured_address.road_abv}`,
            `${structured_address.suburb}`,
            `${structured_address.region} ${structured_address.postcode}`,
          ].join(', ');

          app.internalLocationName = cleanAddress.toLowerCase();
          this.$emit('locationSelected', response.data);
        })
        .catch((error) => {
          console.log(error);
        });

      this.autocompleteList = [];
      this.autocompleteSelected = null;
    },
    autocompleteUpdateValue(value) {

      this.isSelected = false;
      this.debourceHandlerEvent(value);
      this.updateValue(value);
    },
    updateValue(value) {
      this.$emit('input', value);
    },

    checkAutocompleteSelected(){
       if(!this.isSelected){
          this.internalLocationName = "";
       }
    }
  },
};
</script>

<style lang="scss" scoped>
  // @import "../../scss/abstracts/variables";

  label{
    &.name {
      font-family: "Untitled Sans Medium", Arial, sans-serif;
    }
  }
  ul{
    &.form-errors {
      padding: 0 !important;
      list-style: none;
    }
  }
</style>
